import React from 'react';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import PricingDetailAdminList from '../Contents/Sales/PricingDetail/PricingDetailAdminList';
import urlHelper from '../Helpers/urlHelper';
import dateTimeHelper from '../Helpers/datetimeHelper';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import OpportunityStatusEnum from '../Enums/OpportunityStatusEnum';
import JsxHelper from '../Helpers/JsxHelper';
import moneyHelper from '../Helpers/moneyHelper';
import stringHelper from '../Helpers/stringHelper';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LookupText from '../Elements/LookupText';

class PricingListItem {
  constructor(item) {
    if (item === undefined) {
      this.ApprovedBy = '';
      this.ApprovedByName = '';
      this.ApprovedOn = '';
      this.AssignedOn = '';
      this.AssignedTo = '';
      this.AssignedToName = '';
      this.ClientFeeBase = '';
      this.ClientFeeMarkup = '';
      this.ClientFeeTotal = '';
      this.ClientId = '';
      this.ClientName = '';
      this.ClientRevenue = '';
      this.ClientRevenueBase = '';
      this.Cost = '';
      this.CostBase = '';
      this.CountryCode = '';
      this.CountryId = '';
      this.CountryName = '';
      this.CreatedBy = '';
      this.CreatedByName = '';
      this.CreatedOn = '';
      this.CurrencyId = '';
      this.CurrencyName = '';
      this.CurrencyRate = '';
      this.CurrencySymbol = '';
      this.Fee = '';
      this.FieldworkFee = '';
      this.FieldworkFeeBase = '';
      this.FinalizedOn = '';
      this.HasUserComments = '';
      this.ModifiedBy = '';
      this.ModifiedByName = '';
      this.ModifiedOn = '';
      this.NetRevenue = '';
      this.NetRevenueBase = '';
      this.NetRevenuePct = '';
      this.NetRevenuePctBase = '';
      this.NumEvalsPerCycle = '';
      this.NumEvalsTotal = '';
      this.OfficeId = '';
      this.OfficeName = '';
      this.OfficeSalesContact = '';
      this.OpportunityClientFeeTotal = '';
      this.OpportunityCurrencyCode = '';
      this.OpportunityCurrencyId = '';
      this.OpportunityCurrencySymbol = '';
      this.OpportunityDisplayName = '';
      this.OpportunityId = '';
      this.OpportunityIsSingleOffice = '';
      this.OpportunityName = '';
      this.OpportunityNetRevenue = '';
      this.OpportunityOfficeId = '';
      this.OpportunityOfficeName = '';
      this.OpportunityOfficeSameAsPricing = '';
      this.OpportunitySalesRepId = '';
      this.OpportunityStatusCode = '';
      this.OverrideFee = '';
      this.OverrideFeeValue = '';
      this.PricingDetailFinalizedOn = '';
      this.PricingDetailId = '';
      this.PricingDetailName = '';
      this.PricingDetailStatus = '';
      this.PricingDetailStatusCode = '';
      this.PricingDetailVersion = '';
      this.PricingId = '';
      this.RoundFee = '';
      this.ServiceId = '';
      this.ServiceName = '';
      this.ServiceType = '';
      this.Status = '';
      this.StatusCode = '';
      this.Comment = '';
      this.ServiceHasApprovedPricingForThisCountry = '';
      this.OpportunityAssignedToId = '';
      this.PrimarySalesRepId = '';
      this.MysteryShoppingPlatformPricingId = '';
      this.MysteryShoppingPlatformPricingName = '';
      this.CallRecordingCostId = '';
      this.CallRecordingCostName = '';
      this.CsatcostId = '';
      this.CsatcostName = '';
      this.IvrcostId = '';
      this.IvrcostName = '';
    } else {
      this.ApprovedBy = item.approvedBy;
      this.ApprovedByName = item.approvedByName;
      this.ApprovedOn = item.approvedOn;
      this.AssignedOn = item.assignedOn;
      this.AssignedTo = item.assignedTo;
      this.AssignedToName = item.assignedToName;
      this.ClientFeeBase = item.clientFeeBase;
      this.ClientFeeMarkup = item.clientFeeMarkup;
      this.ClientFeeTotal = item.clientFeeTotal;
      this.ClientId = item.clientId;
      this.ClientName = item.clientName;
      this.ClientRevenue = item.clientRevenue;
      this.ClientRevenueBase = item.clientRevenueBase;
      this.Cost = item.cost;
      this.CostBase = item.costBase;
      this.CountryCode = item.countryCode;
      this.CountryId = item.countryId;
      this.CountryName = item.countryName;
      this.CreatedBy = item.createdBy;
      this.CreatedByName = item.createdByName;
      this.CreatedOn = item.createdOn;
      this.CurrencyId = item.currencyId;
      this.CurrencyName = item.currencyName;
      this.CurrencyRate = item.currencyRate;
      this.CurrencySymbol = item.currencySymbol;
      this.Fee = item.fee;
      this.FieldworkFee = item.fieldworkFee;
      this.FieldworkFeeBase = item.fieldworkFeeBase;
      this.FinalizedOn = item.finalizedOn;
      this.HasUserComments = item.hasUserComments === 'Y';
      this.ModifiedBy = item.modifiedBy;
      this.ModifiedByName = item.modifiedByName;
      this.ModifiedOn = item.modifiedOn;
      this.NetRevenue = item.netRevenue;
      this.NetRevenueBase = item.netRevenueBase;
      this.NetRevenuePct = item.netRevenuePct;
      this.NetRevenuePctBase = item.netRevenuePctBase;
      this.NumEvalsPerCycle = item.numEvalsPerCycle;
      this.NumEvalsTotal = item.numEvalsTotal;
      this.OfficeId = item.officeId;
      this.OfficeName = item.officeName;
      this.OfficeSalesContact = item.officeSalesContact;
      this.OpportunityClientFeeTotal = item.opportunityClientFeeTotal;
      this.OpportunityCurrencyCode = item.opportunityCurrencyCode;
      this.OpportunityCurrencyId = item.opportunityCurrencyId;
      this.OpportunityCurrencySymbol = item.opportunityCurrencySymbol;
      this.OpportunityDisplayName = item.opportunityDisplayName;
      this.OpportunityId = item.opportunityId;
      this.OpportunityIsSingleOffice = item.opportunityIsSingleOffice;
      this.OpportunityName = item.opportunityName;
      this.OpportunityNetRevenue = item.opportunityNetRevenue;
      this.OpportunityOfficeId = item.opportunityOfficeId;
      this.OpportunityOfficeName = item.opportunityOfficeName;
      this.OpportunityOfficeSameAsPricing = item.opportunityOfficeSameAsPricing;
      this.OpportunitySalesRepId = item.opportunitySalesRepId;
      this.OpportunityOfficeSalesContact = item.opportunityOfficeSalesContact;
      this.OpportunityStatusCode = item.opportunityStatusCode;
      this.OverrideFee = item.overrideFee;
      this.OverrideFeeValue = item.overrideFeeValue;
      this.PricingDetailFinalizedOn = item.pricingDetailFinalizedOn;
      this.PricingDetailId = item.pricingDetailId;
      this.PricingDetailName = item.pricingDetailName;
      this.PricingDetailStatus = item.pricingDetailStatus;
      this.PricingDetailStatusCode = item.pricingDetailStatusCode;
      this.PricingDetailVersion = item.pricingDetailVersion;
      this.PricingId = item.pricingId;
      this.RoundFee = item.roundFee;
      this.ServiceId = item.serviceId;
      this.ServiceName = item.serviceName;
      this.ServiceType = item.serviceType;
      this.Status = item.status;
      this.StatusCode = item.statusCode;
      this.ServiceHasApprovedPricingForThisCountry = item.serviceHasApprovedPricingForThisCountry;
      this.AcctReptId = item.acctReptId;
      this.OpportunityAssignedToId = item.opportunityAssignedToId;
      this.PrimarySalesRepId = item.primarySalesRepId;
      this.MysteryShoppingPlatformPricingId = item.mysteryShoppingPlatformPricingId;
      this.MysteryShoppingPlatformPricingName = item.mysteryShoppingPlatformPricingName;
      this.CallRecordingCostId = item.callRecordingCostId;
      this.CallRecordingCostName = item.callRecordingCostName;
      this.CsatcostId = item.csatcostId;
      this.CsatcostName = item.csatcostName;
      this.IvrcostId = item.ivrcostId;
      this.IvrcostName = item.ivrcostName;
    }
    this.Selected = false;
  }

  static NameOfTheIdField() {
    return 'PricingDetailId';
  }
  static nameOfTheItemDetailList(item) {
    return item ? `Pricing - ${item.CountryName} (${item.PricingId})` : 'Pricing';
  }
  static MoneyFields = [];
  static NavigationDesc = ['ClientName', 'OpportunityName', 'ServiceName'];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'ServiceName', label: 'Service' },
        { name: (item) => `${item.OpportunityId} - ${item.OpportunityName}`, label: 'Opportunity' },

        { name: 'CountryName', label: 'Country' },
        { name: 'OfficeName', label: 'Office' },
        {
          name: (item) => `${item.PricingDetailVersion} : ${item.OpportunityId} - ${item.OpportunityName}`,
          label: 'Pricing Detail Version',
          width: TabListTableCellWidthEnum.Double,
        },
        {
          name: (item) => (
            <LookupText
              lookupId={23}
              value={item.StatusCode}
            />
          ),
          label: 'Status',
        },
        { name: 'CurrencyName', label: 'Currency' },
        { name: 'NumEvalsPerCycle', label: 'No. Evals Per Cycle' },
        { name: '-', label: '' },
        {
          name: (item) => (item.OpportunityOfficeId === item.OfficeId ? '' : JsxHelper.YesNo(item.RoundFee)),
          label: 'Round Owning Office Fee',
        },
        { name: (item) => JsxHelper.YesNo(item.OverrideFee), label: 'Set Defined Owning Office Fee' },
        {
          name: (item) =>
            item.OpportunityOfficeId === item.OfficeId || item.OverrideFee === false
              ? '-'
              : moneyHelper.toMoneyFormat(item.OverrideFeeValue, item.OpportunityCurrencyCode),
          label: 'Manually Set Owning Office Fee',
        },

        { name: '-', label: '' },
        { name: 'AssignedToName', label: 'Assigned To' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.AssignedOn), label: 'Assigned On' },
        { name: 'ApprovedByName', label: 'Approved By' },

        { name: 'MysteryShoppingPlatformPricingName', label: 'Mystery Shopping Platform Pricing' },
        { name: 'CallRecordingCostName', label: 'Call Recording Cost' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.ApprovedOn), label: 'Approved On' },

        { name: 'CsatcostName', label: 'CSAT Cost' },
        { name: 'IvrcostName', label: 'IVR Cost' },
        { name: '', label: '' },
      ],
    },
    {
      tabName: 'Pricing Detail',
      tabLabel: 'Pricing Versions',
      icon: 'fa-solid fa-bell-concierge',
      data: [
        {
          name: PricingListItem.getPricingDetailsCellContent,
          label: 'Pricing Detail',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: PricingListItem.getSelectedCellHeader,
        orderById: '',
        data: PricingListItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        className: 'text-center',
        minwidth: 20,
        tableminWidth: '35px',
      },
      { label: 'Pricing Id', orderById: 'PricingId', data: 'PricingId', type: FieldTypesEnum.DataFieldWithDetails },
      { label: 'FW Office', orderById: 'OfficeName', data: 'OfficeName' },
      { label: 'Country Name', orderById: 'CountryName', data: 'CountryName' },
      {
        label: 'FW Fee',
        orderById: 'ClientFeeBase',
        data: (item) => moneyHelper.toMoneyFormat(item.ClientFeeBase, item.CurrencyName),
      },
      {
        label: '% Revenue',
        orderById: 'NetRevenuePctBase',
        data: (item) => `${stringHelper.removeTrailingZeros(item.NetRevenuePctBase)} %`,
      },
      { label: '# Evals', orderById: 'NumEvalsTotal', data: 'NumEvalsTotal' },
      { label: 'Status', orderById: 'Status', data: 'Status' },
      { label: 'Assigned To', orderById: 'AssignedToName', data: 'AssignedToName' },
      {
        label: 'Modified On',
        orderById: 'ModifiedOn',
        data: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefiniteIcon(item.ModifiedOn),
      },
      { label: 'Comments?', orderById: 'HasUserComments', data: (item) => JsxHelper.YesNo(item.HasUserComments) },
      {
        label: 'Actions',
        orderById: '',
        data: PricingListItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        tableminWidth: '150px',
      },
    ];
  }

  static getPricingDetailsCellContent(item) {
    return (
      <PricingDetailAdminList
        PricingDetailId={item.PricingDetailId}
        PricingId={item.PricingId}
        Status={
          item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon ||
          item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityLost ||
          ![1, 2, 3, 4].includes(item.StatusCode)
        }
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            disabled:
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon ||
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityLost,
            onClick: () => PricingListItem.editFunction(item.PricingId, item),
          },
        ]}
      />
    );
  }

  static getSelectedCellHeader() {
    return (
      <input
        type='checkbox'
        checked={PricingListItem.selectedStatus()}
        onChange={(e) => {
          PricingListItem.clickOnGlobalSelect(e.target.checked);
        }}
      />
    );
  }
  static selectedStatus() {
    return false;
  }
  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            PricingListItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static clickOnSelect(item, selected) {}

  static editFunction(item) {
    alert(item.OfficeName);
  }

  static StatusChangeFunction(item) {
    alert(item.OfficeName);
  }
  static GetServiceNameNavigationCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.ServiceName,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales_pricing/search',
      `PricingId=${item.PricingId}`,
      'Open up in a new tab'
    );
  }

  static GetPricingIdNavigationCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.PricingId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'pricingitemdetails',
      `id=${item.PricingId}`,
      'Open up in a new tab'
    );
  }

  static GetCountryNameNavigationCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.OfficeName,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'pricingitemdetails',
      `id=${item.PricingId}`,
      'Open up in a new tab'
    );
  }
}

export default PricingListItem;
